import type { Opportunity } from "./entity";

type OpportunityStatus = Opportunity["status"];

/** Remult: `requestApprovedAt` הוא `Date | undefined`; ל־NULL בבסיס הנתונים משתמשים ב־`null` בזמן ריצה */
type PayloadWithNullableRequestApproved = Partial<
  Omit<Opportunity, "requestApprovedAt">
> & {
  requestApprovedAt?: Date | null;
};

type ApprovalSaveContext = {
  isNew: boolean;
  previousStatus?: OpportunityStatus;
};

/**
 * מסנכרן את `requestApprovedAt` לפני שמירה:
 * - יצירה ב־APPROVED → null (לא נחשב "אישור מעבר סטטוס").
 * - יצירה אחרת → מסירים את המפתח מה־payload (לא מקבלים ערך מהלקוח).
 * - עדכון: מעבר ל־APPROVED מסטטוס אחר → עכשיו; יציאה מ־APPROVED → null; אחרת לא נוגעים (מסירים מפתח).
 */
export function applyRequestApprovedAtForSave(
  payload: Partial<Opportunity>,
  ctx: ApprovalSaveContext,
): void {
  const row = payload as PayloadWithNullableRequestApproved;
  const next = row.status;

  if (ctx.isNew) {
    if (next === "APPROVED") {
      row.requestApprovedAt = null;
    } else {
      delete row.requestApprovedAt;
    }
    return;
  }

  const prev = ctx.previousStatus;

  if (next === "APPROVED" && prev !== "APPROVED") {
    row.requestApprovedAt = new Date();
    return;
  }

  if (prev === "APPROVED" && next !== "APPROVED") {
    row.requestApprovedAt = null;
    return;
  }

  delete row.requestApprovedAt;
}
